import adminApi from './adminAPI';

// Client pro endpoint dedicado da tela "Resultados" (/api/v1/admin/resultados/*)
// — agregação própria, não compartilha rota com nenhuma outra tela do painel.
export const adminResultadosAPI = {
  async listarParaFiltro() {
    const { data } = await adminApi.get('/resultados/enquetes');
    return data.enquetes;
  },

  async obter(tipo, id) {
    const { data } = await adminApi.get(`/resultados/${tipo}/${id}`);
    return data.resultado;
  }
};

export default adminResultadosAPI;
